import { useState } from "react";
import type { UseMutateFunction } from "react-query";
import { useMutation } from "react-query";
import { t } from "@/i18n-js/instance";
import { liveStreamApi } from "@circle-react/api";
import type { ApiError } from "@circle-react/config/CustomErrors";
import type { Recorder } from "@circle-react/types/Live/Recorder";
import type { Room } from "@circle-react/types/Live/Room";
import { useToast } from "@circle-react-uikit/ToastV2";

export type CreateRecorderFunction = UseMutateFunction<
  Recorder,
  ApiError,
  string
>;

export const useRecorder = (room?: Room) => {
  const { error } = useToast();
  const [recorder, setRecorder] = useState<Recorder | null>(null);
  const [recordingKey, setRecordingKey] = useState<string | null>(null);

  const createRecorderMutation = useMutation<Recorder, ApiError, string>(
    recording_key => {
      setRecordingKey(recording_key);
      return liveStreamApi.createRecorder({
        id: room?.id,
        recording_key,
      });
    },
    {
      onSuccess: newRecorder => setRecorder(newRecorder),
      onError: response => {
        const errorMessage = response.firstErrorDetail
          ? `${t("live_streams.room.join_error")}: ${response.firstErrorDetail}`
          : `${t("live_streams.room.join_error")}.`;
        error(errorMessage);
      },
    },
  );

  return {
    createRecorder: createRecorderMutation.mutate,
    isCreatingRecorder: createRecorderMutation.isLoading,
    recorder: recorder && { ...recorder, recording_key: recordingKey },
  };
};
